import React         from 'react';
import ReactDOM      from 'react-dom';
import AudioRecorder from 'audio-recorder-polyfill';
import CssBaseline   from '@mui/material/CssBaseline';

import ListingsPage from 'pages/ListingsPage';

import AppTheme from 'components/App/Theme';

window.addEventListener('load', () => {
  const container = document.getElementById('listings-page-wrapper');
  if (!container) return false;

  ReactDOM.render(
    <AppTheme>
      <CssBaseline />
        <ListingsPage companyJson={window.EXTRA_DATA.COMPANY} token={window.EXTRA_DATA.TOKEN}/>
    </AppTheme>,
    container,
  );

  return true;
});
